import { rainbowSurgePaletteLight } from "@mui/x-charts/colorPalettes";

/** Default light-mode palette (matches PieChart default). */
export const STATS_PIE_PALETTE = rainbowSurgePaletteLight;

/**
 * Adds `color` to each pie data row using palette index (wraps).
 * @param {Array<{ id: string, value: number, label: string }>} entries
 * @param {readonly string[]} [palette]
 * @returns {Array<{ id: string, value: number, label: string, color: string }>}
 */
export function applyPieSliceColors(entries, palette = STATS_PIE_PALETTE) {
  return entries.map((entry, index) => ({
    ...entry,
    color: palette[index % palette.length],
  }));
}
